import { BorderBox } from "@/components/atoms/BorderBox";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { isInstanceFieldOptionsWouldBeLostChange, isQuestionConditionalLogicChangedChange, isQuestionFieldPropertiesChangedChange, isQuestionInstanceWasEditedChange, isQuestionMissingChange, isQuestionNotInTemplateChange, isQuestionTypeChangedChange } from "@/features/survey_sync/lib/typeGuards/question";
import { QuestionLevelChangeProps } from ".";
import { OldNewValueChange } from "../../atoms/OldNewValueChange";
import { QuestionConditionalLogicChanged } from "../../atoms/QuestionConditionalLogicChanged";
import { QuestionFieldOptionsChange } from "../../atoms/QuestionFieldOptionsChange";
import { QuestionMissingInInstanceChange } from "../../atoms/QuestionMissingInInstanceChange";
import { QuestionWasEditedChange } from "../../atoms/QuestionWasEditedChange";
import { QuestionInstanceFieldOptionsWouldBeLost } from "../../atoms/QuestionInstanceFieldOptionsWouldBeLost";
import { QuestionNotInTemplateChange } from "../../atoms/QuestionNotInTemplateChange";
import { Autocomplete } from "@/types/utils";
import { CrmSystemIds } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.types.gen";

export function QuestionLevelChange(props: QuestionLevelChangeProps) {
    if (!props.change) return null;
    if (isQuestionTypeChangedChange(props.change)) {
        const fieldTypeResolver = (fieldType: string, crmSystem: Autocomplete<CrmSystemIds>) => {
            try {
                return crmRegistry.getFieldById(crmSystem as CrmSystemIds, fieldType)?.name;
            } catch (e) {
                if (e instanceof Error) {
                    console.error(e.message);
                    return (
                        <BorderBox size="sm" variant={'danger'} className="p-1 text-xs" icon={false}>
                            {e.message}: "{fieldType}"
                        </BorderBox>
                    );
                } else {
                    console.log(e);
                    return "ERROR"
                }
            }
        }
        let oldType = fieldTypeResolver(props.change.context.instanceFieldType, props.instanceCrmSystem);
        let newType = fieldTypeResolver(props.change.context.templateFieldType, props.instanceCrmSystem);

        return (
            <OldNewValueChange
                label="Question type will change"
                oldLabel="From instance"
                oldValue={oldType || "ERROR"}
                newLabel="To template"
                newValue={newType || "ERROR"}
                valueName="field type"
            />
        )
    }
    if (isQuestionFieldPropertiesChangedChange(props.change)) {
        return <QuestionFieldOptionsChange context={props.change.context} />
    }
    if (isQuestionInstanceWasEditedChange(props.change)) {
        return <QuestionWasEditedChange context={props.change.context} />
    }
    if (isQuestionMissingChange(props.change)) {
        return (
            <QuestionMissingInInstanceChange
                templateQuestion={props.change.context.templateQuestion}
            />
        )
    }
    if (isQuestionConditionalLogicChangedChange(props.change)) {
        return (
            <>
                <QuestionConditionalLogicChanged
                    templateConditionals={props.change.context.templateConditionals}
                    instanceConditionals={props.change.context.instanceConditionals}
                />
            </>
        )
    }
    if (isInstanceFieldOptionsWouldBeLostChange(props.change)) {
        return <QuestionInstanceFieldOptionsWouldBeLost context={props.change.context} />
    }
    if (isQuestionNotInTemplateChange(props.change)) {
        return <QuestionNotInTemplateChange context={props.change.context} />
    }
    return (
        <BorderBox size={"sm"} className="flex justify-between">
            <h4 className="font-semibold">Unsupported question change</h4>
            <div className="text-sm text-muted-foreground">{props.change.type}</div>
        </BorderBox>
    )
}

